import { object, string, mixed, InferType } from 'yup';

export const personalInfoSchema = object({
  salutation: string().optional().default(''),
  gender: string().optional().default(''),
  department: string().optional().default(''),
  phone: string().default(''),
  avatar: mixed<File>().nullable().default(null),
});

export type PersonalInfoSchemaType = InferType<typeof personalInfoSchema>;
